
import { PrimeIcons } from '@primevue/core/api';
import router from '../router'
import { getUserRoleId } from './auth'

export function getMenuItems() {
    const roleId = getUserRoleId()
    const items = [
        
    ]

    if (roleId === 2 || roleId === 1) {
        items.push(
            {
                label: 'Inicio',
                icon: 'pi pi-fw pi-home',
                command: () => router.push('/Inicio')
            }
        );
    }

    if ( roleId === 3) {
        items.push({
            label: 'Inicio',
            icon: PrimeIcons.HOME,
            command: () => router.push('/Operador')
        })
    }

    if (roleId === 1) {
        items.push(
            {
                label: 'Usuarios',
                icon: PrimeIcons.USERS,
                command: () => router.push('/AdminUsuario')
            },
            {
                label: 'Operador',
                icon: PrimeIcons.TRUCK,
                command: () => router.push('/Operador')
            }
        )
    }

    if (roleId === 2 || roleId === 1) {
        items.push(
            {
                label: 'Clientes',
                icon: PrimeIcons.BOOK,
                command: () => router.push('/AdminCliente')
            },
        )
    }

    if (roleId === 1 || roleId === 2 || roleId === 3) {
        items.push({
            label: 'Almacenes',
            icon: PrimeIcons.TH_LARGE,
            items:[
                {
                    label:"Almacen Indeasa",
                    icon:PrimeIcons.BOX,
                    command: () => router.push('/Almacen/indaesa')
                },
                {
                    label:"Planta de llenado Apizaco",
                    icon:PrimeIcons.BOX,
                    command: () => router.push('/Almacen/Apizaco')
                }
            ]
            
        })
    }

    if (roleId === 1 || roleId === 2 || roleId === 3) {
        items.push({
            label: 'Orden de servicio',
            icon: PrimeIcons.FILE,
            command: () => router.push('/AdminOrden')
        })
    }

    

    return items
}
